import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Section from '../Section/Section';
import './Avaluo.scss';
import AvaluoForm from './AvaluoForm';
import bem from '../../utils/bem';
import FormHeader from '../FormHeader/FormHeader';
import { IsOnlyNumbers } from '../../utils/helpers';

const Avaluo = ({ fetchAvaluos, avaluos, getAvaluo, sendAvaluo }) => {
  const toProperties = (values) => {
    return Object.keys(values).reduce((acc, curr) => {
      return values[curr]
        ? { ...acc, [curr]: values[curr] }
        : acc;
    }, {});
  }
  return (
    <div className={`gradient ${bem('avaluo', {
      loading: avaluos?.isLoadingAvaluo,
      full: true
    })}`}>
      <FormHeader
        headerText='Solicitud de Avalúo'
        headerSubText='Déjanos tus datos y te contactáremos…'
        bottomBorder
      />
      <Section>
        <h4>Querés un Avalúo Virtual </h4>
        <p>
          Realizá el avalúo del vehículo que pensás entregar de manera virtual.
        </p>
        <Formik
          initialValues={{
            marca: '',
            modelo: '',
            transmision: '',
            vehiculo: '',
            name: '',
            version: '',
            placa: '',
            anio: '',
            km: '',
            estado: '',
            tipo: '',
            combustible: '',
            traccion: '',
          }}
          validationSchema={Yup.object().shape({
            marca: Yup.string().required('Requerido'),
            modelo: Yup.string().required('Requerido'),
            transmision: Yup.string().required('Requerido'),
            placa: Yup.string().required('Requerido'),
            version: Yup.string().required('Requerido'),
            anio: Yup.string().required('Requerido'),
            km: Yup.number().integer().test('len', 'Ingrese un formato correcto con solo números', val => {
              const hasOnlyNumbers = IsOnlyNumbers(val);
              if (!hasOnlyNumbers) {
                return false;
              }
              return true;
            }),
            estado: Yup.string().required('Requerido'),
            tipo: Yup.string().required('Requerido'),
            combustible: Yup.string().required('Requerido'),
            traccion: Yup.string().required('Requerido'),
          })}
          onSubmit={values => {
            getAvaluo(toProperties(values));
          }}
          validateOnMount={true}
        >
          {formik => (
            <AvaluoForm avaluos={avaluos} formik={formik} fetchAvaluos={fetchAvaluos} toProperties={toProperties} sendAvaluo={sendAvaluo} />
          )}
        </Formik>
      </Section>
    </div>
  );
};

export default Avaluo;
